/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, HostBinding, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-list-item',
  templateUrl: 'list-item.component.html',
  styleUrls: ['list-item.component.scss'],
})
export class ListItemComponent {
  @HostBinding('class.is-selected')
  @Input() selected: boolean;
}
